import { render, staticRenderFns } from "./RadishPic.vue?vue&type=template&id=4bb46781&scoped=true&"
import script from "./RadishPic.vue?vue&type=script&lang=js&"
export * from "./RadishPic.vue?vue&type=script&lang=js&"
import style0 from "./RadishPic.vue?vue&type=style&index=0&id=4bb46781&scoped=true&lang=css&"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=4bb46781&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb46781",
  null
  
)

export default component.exports